Ext.define('SA.view.ManageViews', {
    alias: 'widget.manage-views',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-manage-views',

    initComponent() {
        this.items = [
            {
                xtype: 'component',
                cls: 'sa-manage-views-header',
                html: 'Manage Views'
            }, {
                xtype: 'manage-project-views-list',
                project: this.project
            }
        ];

        this.callParent();
    },

    refresh() {
        this.down('manage-project-views-list').refresh();
    }
});